<!-- eslint-disable vue/valid-v-for -->
<template>
	<div>
		<b-row>
			<b-col cols="12">
				<h3>Non CCRIS Items</h3>
			</b-col>
		</b-row>
		<b-card no-body v-loading="is_loading">
			<div class="table-listings">
				<el-table ref="nonCcrisTable" style="width: 100%" size="small" show-summary
					:data="tableData" :header-cell-class-name="'text-13px'" :summary-method="getSummaries">
					<!-- CHECKBOX -->
					<!-- <el-table-column v-if=" _gHlp.checkAccess(allowAssignRoles)" type="selection" class-name="pb-3" width="55" fixed></el-table-column> -->
					<el-table-column type="index" width="50" class-name="text-center font-weight-bold"></el-table-column>

					<!-- <el-table-column label="Date/ R&R" min-width="140" prop="approved_date" sortable has_summary>
						<template slot-scope="scope">
							<el-date-picker
							v-model="scope.row.approved_date"
							format="yyyy-MM-dd"
							value-format="yyyy-MM-dd"
							type="date"
							placeholder="Date/R&R"
							prefix-icon="none"
							clear-icon="none"
							size="mini"
						>
						</el-date-picker>	
						</template>
					</el-table-column>

					<el-table-column label="Capacity" min-width="120" prop="capacity" sortable>
						<template slot-scope="scope">
							<b-form-select v-model="scope.row.capacity" size="sm"
								:disabled="isViewOnly">
								<b-form-select-option v-for="(item,index) in capacityOptions" :key="index" :value="item">{{
									item }}</b-form-select-option>
							</b-form-select>
						</template>
					</el-table-column>

					<el-table-column label="Bank Name" min-width="160" prop="bank_id" sortable>
						<template slot-scope="scope">
							<b-form-select v-model="scope.row.bank_id" size="sm"
								:disabled="isViewOnly">
								<b-form-select-option v-for="item in banksOptions" :key="item.bank_id" :value="item.bank_id">{{
									item.name }}</b-form-select-option>
							</b-form-select>
						</template>
					</el-table-column> -->

					<el-table-column label="Facility" min-width="130" prop="loan_statue" sortable>
						<template slot-scope="scope">
							<b-form-select v-model="scope.row.loan_statue" :options="facilitiesOptions" :disabled="isViewOnly" size="sm"></b-form-select>
						</template>
					</el-table-column>

					<el-table-column label="Description" min-width="180" prop="remark" sortable>
						<template slot-scope="scope">
							<b-form-input v-model="scope.row.remark" type="text" :disabled="isViewOnly" size="sm"></b-form-input>
						</template>
					</el-table-column>

					<!-- <el-table-column label="Sts" min-width="80" prop="sts" sortable>
						<template slot-scope="scope">
							<b-form-select v-model="scope.row.sts" size="sm"
								:disabled="isViewOnly">
								<b-form-select-option v-for="(item,index) in stsOptions" :key="index" :value="item">{{
									item }}</b-form-select-option>
							</b-form-select>
						</template>
					</el-table-column> -->

					<el-table-column label="Outstanding" min-width="150" prop="current_outstanding" sortable
						class-name="text-right">
						<template slot-scope="scope">
							<CurrencyInput className="text-right" v-model="scope.row.current_outstanding" size="sm"
								:disabled="isViewOnly" :options="{ currency: 'MYR', currencyDisplay: 'narrowSymbol', autoDecimalDigits: true }" />
						</template>
					</el-table-column>

					<el-table-column label="Settlement" min-width="150" prop="invinity_solution" sortable>
						<template slot-scope="scope">
							<CurrencyInput className="text-right" v-model="scope.row.invinity_solution" size="sm"
								:disabled="!scope.row.is_settled || isViewOnly"
								:options="{ currency: 'MYR', currencyDisplay: 'narrowSymbol', autoDecimalDigits: true }" />
						</template>
					</el-table-column>
					<!-- <el-table-column label="Other Solution" min-width="150" prop="other_solution" sortable>
						<template slot-scope="scope">
							<CurrencyInput className="text-right" v-model="scope.row.other_solution" size="sm"
								:disabled="!scope.row.is_settled || isViewOnly"
								:options="{ currency: 'MYR', currencyDisplay: 'narrowSymbol', autoDecimalDigits: true }" />
						</template>
					</el-table-column> -->

					<el-table-column label="Settle" min-width="100" prop="is_settled" sortable>
						<template slot-scope="scope">
							<el-switch v-model="scope.row.is_settled" active-color="#099A78"
								@change="handleChangeSettle(scope.row, scope.$index)" :disabled="isViewOnly"></el-switch>
						</template>
					</el-table-column>

					<el-table-column min-width="30" fixed="right" v-if="!isViewOnly">
						<template slot-scope="scope">
							<el-dropdown trigger="click" style="cursor: pointer">
								<p class="el-dropdown-link mb-0 top-line">
									<b-icon icon="three-dots-vertical" scale="1.5"></b-icon>
								</p>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item @click.native="removeItem(scope.row.id, scope.$index)">
										<span class="text-danger">
											<!-- Trash-Can Icon -->
											<svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 576 512">
												<path fill="#DF3030"
													d="M135.2 17.7C140.6 6.8 151.7 0 163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3zM32 128H416V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm96 64c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16z" />
											</svg>
											Delete
										</span>
									</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
						</template>
					</el-table-column>

				</el-table>
			</div>
			<div class="text-right p-2" v-if="!isViewOnly">
				<el-button type="primary" class="mx-1" size="mini" @click="addItem" icon="el-icon-circle-plus-outline"> Add</el-button>
				<el-button type="warning" class="mx-1" size="mini" @click="submitAndCalculate" icon="el-icon-circle-check">Save & Calculate</el-button>
			</div>
		</b-card>
	</div>
</template>
<script>
import {cloneDeep, isEqual} from 'lodash'
import { Switch, Table, TableColumn, Button, Select, Option, Dropdown, DropdownItem, DropdownMenu, DatePicker } from 'element-ui';
import { gEventBus } from '@/assets/js/EventBus/gEventBus.js'
import CurrencyInput from '@/components/CurrencyInput';
import { mapState, mapActions } from 'pinia';
import { useCommonStore } from '@/stores/commonStore';
import { useCustomerStore } from '@/stores/customerStore';
import { useCreditReportStore } from '@/stores/creditReportStore';

export default {
	props: ['is-view-only'],
	components: {
		CurrencyInput,
		[Table.name]: Table,
		[TableColumn.name]: TableColumn,
		[Button.name]: Button,
		[Switch.name]: Switch,
		[Select.name]: Select,
		[Option.name]: Option,
		[DatePicker.name]: DatePicker,
		[Dropdown.name]: Dropdown,
		[DropdownItem.name]: DropdownItem,
		[DropdownMenu.name]: DropdownMenu,
	},
	data() {
		return {
			is_loading_rows: [],
			oldTableData: [],
			tableData: [],
			tableSummary: {},
			tableColumnSkipSummary: [0, 1, 2, 5, 6],
			formData:{
				nonCcrisItemsSettleList:[],
				non_ccris_commitment:0,
				non_ccris_settlement:0,
				final_installment:0,
			},
			banksOptions: [],
			deletedItemIds:[],
			facilitiesOptions: [],
			capacityOptions: [
					'Own',
					'Joint',
					'Sole',
					'Partner',
					'Prof',
					'Other not in Lists',
			],
			stsOptions: [
					"CCRIS",
					"AKPK",
					"SAA",
					"Legal",
					"Restructure",
					"Koperasi",
					"Trade Reference",
					"PTPTN - Ujrah",
					"Bankruptcy",
					"Summon",
					"SAS (Legal) - 10",
					"SAA (Legal) - 11",
					"SAA (Legal) - 18",
					"CCRIS (Legal) - 10",
					"CCRIS (Legal) - 11",
					"Others"
			]
		}
	},
	created() {
		this.getBanks()
		this.getFacilityOptions();
		this.initComponent();
	},
	beforeDestroy() {
		this.clearComponent()
	},
	beforeUnmount(){
		this.clearComponent()
	},
	computed: {
		...mapState(useCustomerStore, ['activeLoanECNonCcriss', 'activeLoanEC','activeFormLoanEc']),
		is_loading(){
			return _gHlp.isLoading('fetch_non_ccris_items') || _gHlp.isLoading('fetch_loan_ec')
		}
	},
	watch: {
		activeFormLoanEc: {
			handler(newVal) {
				if (!_gHlp.isEmpty(newVal)) {
					this.formData = { ...this.formData, ...newVal }
				}
			},
			immediate: true
		},
		activeLoanECNonCcriss: {
			handler(newVal) {
				if (!_gHlp.isEmpty(newVal)) {
					this.initComponent();
				}
			},
			immediate: true
		},
		tableSummary: {
			handler(newVal) {
				if (!_gHlp.isEmpty(newVal)) {
					this.callbackTableSummary(newVal);
				}
			},
			immediate: true
		}
	},
	methods: {
		...mapActions(useCommonStore, ['getTables','getDroplist']),
		...mapActions(useCustomerStore, ['getNonCCRISCommitmentList', 'createOrUpdateNonCCRISItems', 'deleteNonCCRISItems','setFormLoanEc']),
		clearComponent(){
			this.is_loading_rows = []
			this.oldTableDatac = []
			this.tableData = []
			this.tableSummary = {}
			this.formData = {
				nonCcrisItemsSettleList:[],
				non_ccris_commitment:0,
				non_ccris_settlement:0,
				final_installment:0,
			}
			this.deletedItemIds = []
		},
		initComponent() {
			_gHlp.setLoading('fetch_non_ccris_items')
			this.fetcAllRelations(this.activeLoanECNonCcriss)
		},
		fetcAllRelations(resp){
			this.tableData = [];
			if (!_gHlp.isEmpty(resp) && !_gHlp.isEmpty(resp.data)) {
				this.tableData = resp.data.map(itm => ({
					...itm,
					is_settled: (itm.is_include == 1)
				}));
			}
			this.setOldData()
			_gHlp.removeLoading('fetch_non_ccris_items')
		},
		setOldData(){
			this.oldTableData = cloneDeep(this.tableData)
		},
		getSummaries(param) {
			const { columns, data } = param;
			const sums = [];
			const cbData = [];

			columns.forEach((column, index) => {
				if (index === 2) {
					sums[index] = 'Total';
					return;
				}
				if (this.tableColumnSkipSummary.includes(index)) {
					return;
				}

				const values = data.map(item => {
					return Number(item[column.property])
				});
				if (!values.every(value => isNaN(value))) {
					const total = values.reduce((prev, curr) => {
						const value = Number(curr);
						if (!isNaN(value)) {
							return prev + curr;
						} else {
							return prev;
						}
					}, 0);

					sums[index] = 'RM ' + total.toLocaleString('en-MY', { minimumFractionDigits: 2 });
					cbData[column.property] = total
				} else {
					sums[index] = '';
				}
			});

			//callback
			this.tableSummary = cbData;
			return sums;
		},
		callbackTableSummary(data, save=false) {
			this.formData.nonCcrisItemsSettleList = this.tableData.filter((item) => { return item.is_include == 1 });
			this.formData.non_ccris_outstanding = !_gHlp.isEmpty(data) ? parseFloat(data.current_outstanding) : 0;
			this.formData.non_ccris_settlement = !_gHlp.isEmpty(data) ? parseFloat(data.invinity_solution) : 0;
			// this.formData.final_installment = !_gHlp.isEmpty(data) ? parseFloat(data.final_installment) : 0;
			this.setFormLoanEc(this.formData)
			this.$emit('change',save);
		},
		addItem() {
			this.tableData.push({
				id: null,
				// approved_date:null,
				// capacity:'',
				// sts:'',
				// bank_id:null,
				loan_statue: '',
				remark: '',
				current_outstanding: 0,
				invinity_solution: 0,
				is_include: 0,
				is_settled: false
			})
		},
		getBanks() {
			this.getTables('banks').then(resp => {
				this.banksOptions = resp.banks;
			});
		},
		getFacilityOptions() {
			this.getDroplist('lec_non_ccris').then((res) => {
				this.facilitiesOptions = res;
			});
		},
		handleChangeSettle(item, index) {
			if (item.is_settled) {
				item.invinity_solution = item.current_outstanding;
				// item.final_installment = 0;
				item.is_include = 1;
			} else {
				item.is_include = 0;
				item.invinity_solution = 0;
				// item.final_installment = item.current_installment;
			}	
			this.tableData[index] = item;
		},
		removeItem(id, index) {
			// Check if the index is within the array bounds
			if (index >= 0 && index < this.tableData.length) {
				// Use splice to remove the item at the specified index
				if (!_gHlp.isEmpty(id)) {
					if(this.tableData.find(x => x.id == id)){
						this.deletedItemIds.push(id);
					}
				}
				this.tableData.splice(index, 1);
			}
		},
		getParams(item) {
			if(_gHlp.isEmpty(item)) return {}
			
			return {
				// bank_id: item.bank_id,
				current_outstanding: parseFloat(item.current_outstanding),
				invinity_solution: parseFloat(item.invinity_solution),
				// final_installment: item.final_installment,
				is_include: item.is_include,
				// capacity: item.capacity,
				// approved_date: item.approved_date,
				// sts: item.sts,
				loan_statue: item.loan_statue,
				remark: item.remark,
				// credit_limit: item.ccris_sum_credit_limit,
				// current_installment: item.ccris_sum_current_installment,
				id: item.id
			}
		},
		submitAndCalculate(){
			let updateItems = [];
			//DELETD ITEMS
			if(!_gHlp.isEmpty(this.deletedItemIds)){
				for(let i = 0; i < this.deletedItemIds.length; i++){
					let itmId = this.deletedItemIds[i];
					updateItems.push(this.deleteNonCCRISItems(itmId))
				}
			}

			//UPDATE ITEMS
			for (let idx = 0; idx < this.tableData.length; idx++) {
				const newData = this.getParams(this.tableData[idx])	
				const oldData = this.getParams(this.oldTableData.find(itm => itm.id === newData.id));
				if(_gHlp.isEmpty(oldData) || !isEqual(newData, oldData)) {
					updateItems.push(this.createOrUpdateNonCCRISItems(newData));
				}
			}
			
			if(!_gHlp.isEmpty(updateItems)){
				_gHlp.setLoading('fetch_non_ccris_items')
				Promise.all(updateItems)
				.then(res  => {
					this.callbackTableSummary(this.tableSummary,true)
					this.getNonCCRISCommitmentList().then(resp => {
						this.fetcAllRelations(resp)
						this.deletedItemIds = [];
					})
					_gHlp.removeLoading('fetch_non_ccris_items')
				})
				.catch(e => {
					_gHlp.removeLoading('fetch_non_ccris_items')
				})
			}
		}
	}
}
</script>